import React, { useEffect } from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import './Login.css';
import Index from '../Index';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { LoginActionHandler } from '../../Redux/Actions/common/Login';
// import { notification } from "antd";

const Login = () => {
    const mainLogo = '/assets/QA_Logo.svg';
    let dispatch = useDispatch();
    let Navigate = useNavigate();
    // const [api, contextHolder] = notification.useNotification();

    const logindata = useSelector((state) => state?.LoginData?.login_data);
    // const openNotificationWithIcon = (type) => {
    //   api[type]({
    //     message: logindata?.message,
    //   });
    // };

    useEffect(() => {
        if (logindata?.data?.challenge) {
            localStorage.setItem('session', logindata.data.session);
            if (logindata?.data?.challenge === 'NEW_PASSWORD_REQUIRED') {
                setTimeout(() => {
                    Navigate('/new-password');
                }, 2000);
            } else {
                setTimeout(() => {
                    Navigate('/mfauthentication');
                }, 2000);
            }
        } else if (logindata?.data?.token) {
            // openNotificationWithIcon("success");
            localStorage.setItem('token', logindata.data.token);
            localStorage.setItem('refresh_token', logindata.data.refresh_token);
            localStorage.setItem(
                'userDetails',
                JSON.stringify(logindata.data.user)
            );
            if (
                logindata?.data?.client_mfa_enabled === true &&
                !logindata?.data?.is_mfa_enabled
            ) {
                console.log('Navigated from Login');
                Navigate('/multi-factor');
            } else {
                if (logindata?.data?.subscription === null) {
                    // Navigate("/");
                    Navigate('/settings/billing');
                } else {
                    Navigate('/');
                }
            }
        }
        // eslint-disable-next-line
    }, [logindata]);
    console.log(logindata, 'logindata');
    const onFinish = (values) => {
        localStorage.setItem('session_email', values.email);
        dispatch(LoginActionHandler(values));

        //gtm
        window.dataLayer.push({
            event: 'Sign In ',
            buttonName: 'Sign In',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
    };
    return (
        <>
            <div className='login-container'>
                <Index />
                {/* {contextHolder} */}
                <div className='login-main auth-custom-scrollbar'>
                    <div className='login-div '>
                        <div className='center-img'>
                            <img
                                src={mainLogo}
                                alt=''
                                className='centered-image'
                            />
                        </div>

                        <p className='back_text'>Welcome Back!</p>
                        <p className='login_text-h'>Log in to your account</p>

                        <Form
                            name='loginForm'
                            initialValues={{ email: '', password: '' }}
                            onFinish={onFinish}
                            className='login-class-form'>
                            <label>Your email</label>
                            <Form.Item
                                name='email'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your email!',
                                    },
                                    {
                                        type: 'email',
                                        message:
                                            'Please enter a valid email address',
                                    },
                                ]}>
                                <Input placeholder='Enter your email' />
                            </Form.Item>

                            <label>Password</label>
                            <Form.Item
                                name='password'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter your password!',
                                    },
                                    {
                                        min: 8,
                                        message:
                                            'Password must be at least 8 characters long',
                                    },
                                ]}>
                                <Input.Password placeholder='Enter your password' />
                            </Form.Item>

                            <Form.Item>
                                <Form.Item
                                    name='remember'
                                    valuePropName='checked'
                                    noStyle>
                                    <Checkbox className='mylogin-checked form-custom-checkbox'>
                                        Keep me signed in
                                    </Checkbox>
                                </Form.Item>

                                <Link
                                    to='/forgotPassword'
                                    style={{
                                        float: 'right',
                                        color: '#ee3e38',
                                    }}>
                                    <LockOutlined
                                        style={{
                                            color: 'red',
                                            marginRight: '8px',
                                        }}
                                    />
                                    Forgot password
                                </Link>
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type='primary'
                                    htmlType='submit'
                                    block
                                    className='submit_login-btn'>
                                    Sign in
                                </Button>
                            </Form.Item>

                            <div className='first-time_div'>
                                Don't have an account?{' '}
                                <Link to='/signup'>
                                    <span>Sign up</span>
                                </Link>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
